<template>
  <faq-list v-if="response.length" :response="response"></faq-list>
</template>

<script>
export default {
  name: 'ViewFaqIndex',
  components: {
    FaqList: () => import('@/pages/faq/components/FaqList'),
  },
  props: {
    response: {
      type: Array,
      require: true,
    },
  },
  metaInfo: {
    title: 'Как покупать и продавать бензин оптом выгодно | OPEN OIL MARKET',
    meta: [
      {
        name: 'description',
        content:
          'Заказ, оплата и доставка нефтепродуктов, дизельного топлива, бензина, моторных масел онлайн',
      },
      {
        name: 'keywords',
        content:
          'гарантии подтверждение цена счет отсрочка сделка покупка продажа бензин дизель дт дизельное топливо керосин гсм АИ-95 АИ-92 АИ-98 АИ-100',
      },
    ],
  },
};
</script>

<style lang="scss" scoped>
.ViewFaqIndex {
  // -
}
</style>
